interface StaffEmailMapping {
    [key: string]: {
        [company: string]: string;
    };
}

export const staffEmailMapping: StaffEmailMapping = {
    'Leadersromansgroup': {
        'Adrian Plant': 'aplant@sownso.co.uk',
        'Bernardo Lourenco': 'BLourenco@sown.co.uk',
        'Gemma Gibson': 'GeGibson@sown.co.uk',
        'Jake Butler': 'JaButler@sown.co.uk',
        'Kornelija Zilinskaite': 'kzilinskaite@sown.co.uk',
        'Lyndon Farrar': 'lfarrar@sownso.co.uk',
        'Monic Chhabria': 'mchhabria@sown.co.uk',
        'Peter Hawley': 'phawley@sownso.co.uk',
        'Sanjay Paul': 'spaul@sownso.co.uk',
        'Tia Redmile': 'tredmile@sown.co.uk',
        'Rumon Kauser': 'rkauser@sown.co.uk',
        'Natalie Painter': 'npainter@sown.co.uk',
        'Patrick Hill': 'pahill@sown.co.uk',
    },
};

export const handleStaffEmailChange = (
    selectedName: string,
    company: 'Leadersromansgroup'
): string => {
    return staffEmailMapping[company][selectedName] || '';
};